import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { ConfirmPendingTraining } from "@interfaces/confirmPendingTraining.interface";
import { Service } from "@services/service";

@Injectable()
export class TrainingService extends Service {
	constructor(injector: Injector) {
		super("Training", injector);
	}

	// API
	confirmPending(data: ConfirmPendingTraining) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ConfirmPending`, data );
	}

	downloadCertificate(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/DownloadCertificate/${id}`, { responseType: "blob" as "json"} );
	}

	downloadTrainingReport() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/DownloadTrainingReport`, { responseType: "blob" as "json"} );
	}

	getTrainingForUserProfileId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/TrainingForUserProfileId/${id}`);
	}

	isUserTrainedForMachinee(userProfileId: number, machineId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/IsUserTrainedForMachine/${userProfileId}/${machineId}`);
	}

	usersTrainedForMachine(machineId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/UsersTrainedForMachine/${machineId}`);
	}
}